import React from "react";
import research from "./assets/research.svg";
import Fade from "react-reveal/Fade";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
const Main3 = () => {
  const theme = useTheme();

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  return (
    <section className="about overflow-hidden py-5">
      <div className="w-100">
        <div className="row col-md-11 mx-auto ">
          <div className="col-md-6 img">
            <Fade duration={4000} left>
              <img src={`${research}`} alt="" className="img-fluid" />
            </Fade>
          </div>
          <div className="col-md-6 ps-2">
            <Fade duration={4000} right className="about">
              <Grid
                item
                xs={12}
                md={6}
                alignItems={"left"}
                sx={{
                  width: "100%",
                }}
              >
                <Box
                  data-aos={isMd ? "fade-right" : "fade-up"}
                  paddingLeft={isMd && 2}
                  p={1}
                >
                  <Box marginBottom={3}>
                    <Typography
                      variant="h6"
                      component="ul"
                      color="#fff"
                      style={{
                        fontFamily: "Arizona",
                        textAlign: "left",
                        fontSize: "1.3rem",
                        fontWeight: "400",
                      }}
                    >
                      <li>
                        Successfully published a Research paper at the IEEE
                        conference 2024 held at Amity University, Greater Noida
                      </li>
                      <button
                        className="Button-1"
                        style={{
                          display: "flex",
                          margin: "auto",
                          marginTop: "15px",
                        }}
                        onClick={() => {
                          window.open(
                            "https://ieeexplore.ieee.org/document/10593497"
                          );
                        }}
                      >
                        LookOut
                      </button>
                      <br />
                      <li>
                        Published a patent in the field of invention on
                        Biomedical Engineering Field under Intellectual Property
                        Rights
                      </li>
                      <button
                        className="Button-1"
                        style={{
                          display: "flex",
                          margin: "auto",
                          marginTop: "15px",
                        }}
                        onClick={() => {
                          window.open(
                            "https://www.linkedin.com/posts/ashwani-verma-64953820a_research-innovation-esvasthya-activity-7103981573326200833-mqlY/?utm_source=share&utm_medium=member_desktop"
                          );
                        }}
                      >
                        LookOut
                      </button>
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Main3;
